"use strict";

var _from = require("babel-runtime/core-js/array/from");

var _from2 = _interopRequireDefault(_from);

var _set = require("babel-runtime/core-js/set");

var _set2 = _interopRequireDefault(_set);

var _getOwnPropertySymbols = require("babel-runtime/core-js/object/get-own-property-symbols");

var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _create = require("babel-runtime/core-js/object/create");

var _create2 = _interopRequireDefault(_create);

var _setPrototypeOf = require("babel-runtime/core-js/object/set-prototype-of");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = undefined && undefined.__extends || function () {
    var extendStatics = _setPrototypeOf2.default || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? (0, _create2.default)(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = undefined && undefined.__assign || _assign2.default || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof _getOwnPropertySymbols2.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols2.default)(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classNames = require("classnames");
var next_1 = require("@alicd/next");
var CascaderMenu_1 = require("./CascaderMenu");
var Common_1 = require("./Common");
var CheckboxState;
(function (CheckboxState) {
    CheckboxState[CheckboxState["Checked"] = 0] = "Checked";
    CheckboxState[CheckboxState["Indeterminate"] = 1] = "Indeterminate";
    CheckboxState[CheckboxState["Unchecked"] = 2] = "Unchecked";
})(CheckboxState || (CheckboxState = {}));
var AddressEntry = /** @class */function (_super) {
    __extends(AddressEntry, _super);
    function AddressEntry(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChangeCheckbox = _this.handleChangeCheckbox.bind(_this);
        _this.handleMenuClick = _this.handleMenuClick.bind(_this);
        _this.handleChangeHotarea = _this.handleChangeHotarea.bind(_this);
        return _this;
    }
    AddressEntry.prototype.isChecked = function (props) {
        if (props === void 0) {
            props = this.props;
        }
        return props.value == CheckboxState.Checked;
    };
    AddressEntry.prototype.handleChangeCheckbox = function (checked) {
        this.props.onChangeCheckbox && this.props.onChangeCheckbox(checked, this.props.node);
    };
    AddressEntry.prototype.handleChangeHotarea = function () {
        return this.handleChangeCheckbox(this.isChecked());
    };
    AddressEntry.prototype.handleMenuClick = function () {
        this.props.onMenuClick && this.props.onMenuClick(this.isChecked(), this.props.node);
    };
    AddressEntry.prototype.showArrow = function (props) {
        if (props === void 0) {
            props = this.props;
        }
        if (props.node.isLeaf) {
            return false;
        }
        if (props.node.children && props.node.children.length && props.node.children[0].level > props.level) {
            return false;
        }
        if (props.level < 4 && (!props.node.children || !props.node.children.length)) {
            return false;
        }
        return true;
    };
    AddressEntry.prototype.render = function () {
        var _a = this.props,
            node = _a.node,
            value = _a.value,
            onChangeCheckbox = _a.onChangeCheckbox,
            onMenuClick = _a.onMenuClick,
            active = _a.active,
            level = _a.level,
            rest = __rest(_a, ["node", "value", "onChangeCheckbox", "onMenuClick", "active", "level"]);
        var Checkbox = next_1.Checkbox;
        return React.createElement(CascaderMenu_1.default.Item, __assign({ key: node.id.toString(), className: classNames("cn-addr-casitem", { "cn-addr-casactive": this.props.active }), onClick: this.handleMenuClick }, rest), React.createElement(Checkbox, { checked: this.isChecked(), indeterminate: value == CheckboxState.Indeterminate, onChange: this.handleChangeCheckbox }), React.createElement("span", { className: "cn-addr-castext" }, node.nameZh), !this.showArrow() ? null : React.createElement(next_1.Icon, { className: "cn-addr-casexpand", type: "arrow-right", size: "xs" }));
    };
    AddressEntry.propTypes = {
        node: PropTypes.object,
        value: PropTypes.number,
        onChangeCheckbox: PropTypes.func,
        onMenuClick: PropTypes.func,
        active: PropTypes.bool,
        level: PropTypes.number
    };
    return AddressEntry;
}(React.Component);
var CNAddressCascader = /** @class */function (_super) {
    __extends(CNAddressCascader, _super);
    function CNAddressCascader(props) {
        var _this = _super.call(this, props) || this;
        _this.valueSet = new _set2.default();
        _this.allParentSet = new _set2.default();
        _this.activeChainSet = new _set2.default();
        _this.renderMenu = _this.renderMenu.bind(_this);
        _this.handleMenuClick = _this.handleMenuClick.bind(_this);
        _this.handleChangeCheckbox = _this.handleChangeCheckbox.bind(_this);
        return _this;
    }
    CNAddressCascader.prototype.handleMenuClick = function (checkedNode, node) {
        this.props.onExpand(node.id);
    };
    CNAddressCascader.prototype.handleChangeCheckbox = function (checked, node) {
        var _this = this;
        var changed = false;
        if (!checked && this.valueSet.has(node.id)) {
            this.valueSet.delete(node.id);
            changed = true;
        } else if (checked && !this.valueSet.has(node.id)) {
            this.valueSet.add(node.id);
            changed = true;
        } else if (!checked && !this.valueSet.has(node.id)) {
            var nodeToDestruct = this.props.allNodesSet[node.id.toString()];
            while (true) {
                if (this.valueSet.has(nodeToDestruct.id)) {
                    break;
                }
                if (nodeToDestruct.parentNode) {
                    nodeToDestruct = nodeToDestruct.parentNode;
                } else {
                    return;
                }
            }
            var parentSet_1 = Common_1.getParentSetOf(node);
            this.valueSet.delete(nodeToDestruct.id);
            if (nodeToDestruct.children && node.parentNode) {
                var filterAndAdd = function filterAndAdd(child) {
                    if (!parentSet_1.has(child.id)) {
                        _this.valueSet.add(child.id);
                    }
                };
                var nodeChain = Common_1.nodeChainFromNode(node);
                nodeChain = nodeChain.slice(nodeChain.indexOf(nodeToDestruct));
                nodeChain.pop();
                for (var _i = 0, nodeChain_1 = nodeChain; _i < nodeChain_1.length; _i++) {
                    var currentNode = nodeChain_1[_i];
                    currentNode.children.forEach(filterAndAdd);
                }
                changed = true;
            }
        }
        changed && this.props.onChange && this.props.onChange((0, _from2.default)(this.valueSet));
    };
    CNAddressCascader.prototype.renderMenu = function (node, zIndex, valueSet, allParentSet, activeChainSet) {
        var _this = this;
        if (node.isLeaf) {
            return null;
        }
        return React.createElement(CascaderMenu_1.default, { className: "cn-addr-caslist", key: node.id.toString(), style: { zIndex: zIndex } }, node.children.map(function (child) {
            if (_this.props.hiddenMap[child.id.toString()]) {
                return null;
            }
            var c = CheckboxState.Unchecked;
            if (valueSet.has(child.id) || Common_1.isDescendantOfOne(_this.props.allNodesSet, child.id, _this.props.value)) {
                c = CheckboxState.Checked;
            } else if (allParentSet.has(child.id)) {
                c = CheckboxState.Indeterminate;
            }
            return React.createElement(AddressEntry, { key: child.id.toString(), node: child, onMenuClick: _this.handleMenuClick, value: c, onChangeCheckbox: _this.handleChangeCheckbox, active: activeChainSet.has(child.id), level: _this.props.level });
        }));
    };
    CNAddressCascader.prototype.render = function () {
        var _this = this;
        var nodeChain = Common_1.nodeChainFromNode(this.props.allNodesSet[this.props.expandedValue.toString()]);
        var rootPos = nodeChain.findIndex(function (n) {
            return n.id == _this.props.rootNodeId;
        });
        if (rootPos != -1) {
            nodeChain = nodeChain.slice(rootPos);
        }
        this.valueSet = new _set2.default();
        this.props.value.forEach(function (v) {
            return _this.valueSet.add(v);
        });
        this.allParentSet = new _set2.default();
        this.props.value.forEach(function (v) {
            var parentNodeChain = Common_1.nodeChainFromNode(_this.props.allNodesSet[v.toString()]);
            parentNodeChain.forEach(function (node) {
                return _this.allParentSet.add(node.id);
            });
        });
        this.activeChainSet = new _set2.default();
        nodeChain.forEach(function (v) {
            return _this.activeChainSet.add(v.id);
        });
        var menus = nodeChain.filter(function (node) {
            return node.level < _this.props.level && !(_this.props.level < 4 && (node.isLeaf || !node.children || !node.children.length));
        }).map(function (node, idx) {
            return _this.renderMenu(node, nodeChain.length - idx + 12, _this.valueSet, _this.allParentSet, _this.activeChainSet);
        });
        return React.createElement("span", { className: "cn-addr-casmenu" }, menus);
    };
    CNAddressCascader.propTypes = {
        addressTree: PropTypes.object,
        allNodesSet: PropTypes.object,
        expandedValue: PropTypes.string,
        onExpand: PropTypes.func,
        onLoadTown: PropTypes.func,
        value: PropTypes.arrayOf(PropTypes.string),
        onChange: PropTypes.func,
        rootNodeId: PropTypes.string,
        level: PropTypes.number,
        hiddenMap: PropTypes.object
    };
    CNAddressCascader.defaultProps = {
        value: []
    };
    return CNAddressCascader;
}(React.Component);
exports.default = CNAddressCascader;
//# sourceMappingURL=CNAddressCascader.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-address@0.0.80@@alicd/crui-address/lib/CNAddressCascader.js
// module id = 560
// module chunks = 0